module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "symetriaLogo.e3417d33.png";